export function useSize() {
    const { width, height } = useWindowSize();

    const bigger = computed(() => ({
        'sm': width.value >= 640,
        'md': width.value >= 768,
        'lg': width.value >= 1024,
        'xl': width.value >= 1280,
        '2xl': width.value >= 1536,
    }));

    const smaller = computed(() => ({
        'sm': width.value < 640,
        'md': width.value < 768,
        'lg': width.value < 1024,
        'xl': width.value < 1280,
        '2xl': width.value < 1536,
    }));

    return reactive({ width, height, bigger, smaller });
}
